import React from 'react';
import { useTranslation } from 'react-i18next';
import { SEO } from '../components/SEO';
import { HomeHero } from '../components/HomeHero';
import { Services } from '../components/Services';

export const HomePage = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <SEO 
        title={t('companyName')}
        description={t('companyDescription')}
        keywords="SPID, Consultants, IT, conseil, solutions digitales, architecture, implémentation, services informatiques, transformation numérique"
        type="website"
      />
      <HomeHero />
      <Services />
    </>
  );
};

export default HomePage;
